export default "__VITE_ASSET__1cb44707__"